import React, { createContext, useContext } from 'react';

interface MSGReadOnlyContextType {
  isReadOnly: boolean;
}

const defaultContext: MSGReadOnlyContextType = {
  isReadOnly: false
};

export const MSGReadOnlyContext = createContext<MSGReadOnlyContextType>(defaultContext);

export const MSGReadOnlyProvider: React.FC<{ isReadOnly?: boolean, children: React.ReactNode }> = ({
  isReadOnly = false,
  children
}) => {
  return (
    <MSGReadOnlyContext.Provider value={{ isReadOnly }}>
      {children}
    </MSGReadOnlyContext.Provider>
  );
};

export const useMSGReadOnly = () => useContext(MSGReadOnlyContext);
